import { procedureRecallTool } from "./recall-tool";
import { createRecallTool } from "./recall-tool/pages/recall-create";
import { recallToolDetail } from "./recall-tool/pages/recall-detail";

import { procedureExportWarehouse } from "./export-warehouse";
import { exportWarehouseDetail } from "./export-warehouse/pages/export-detail";
import { createExportWarehouse } from "./export-warehouse/pages/export-create";
import { Icon } from "../../../components";

export const planningDepartmentRoutes: any = {
  //Recommend the planning department
  procedurePlanningDepartment : {
    isAdmin: false,
    title: "KẾ HOẠCH ĐẦU TƯ",
    path: "/procedure/recall-tool",
    parentId: "procedure",
    icon: Icon.Checked(),
    component: procedureRecallTool,
  },
  procedureRecallTool: {
    isAdmin: false,
    title: "1. Đề nghị thu hồi CCDC",
    path: "/procedure/recall-tool",
    parentId: "procedure",
    component: procedureRecallTool,
  }, 
  createRecall: {
    isAdmin: false,
    title: "Tạo mới",
    path: "/procedure/recall-tool/new/:id",
    parentId: "procedure",
    component: createRecallTool,
  },
  recallToolDetailPage: {
    path: "/procedure/recall-tool/details/:id",
    parentId: "procedure",
    component: recallToolDetail,
  },
  procedureExportWarehouse: {
    path: "/procedure/export-warehouse",
    parentId: "procedure",
    title: "2. Đề nghị xuất kho",
    component: procedureExportWarehouse,
  },
  exportWarehouseDetail: {
    path: "/procedure/export-warehouse/details/:id",
    parentId: "procedure",
    component: exportWarehouseDetail,
  },
  createExportWarehouse: {
    isAdmin: false,
    title: "Tạo mới",
    path: "/procedure/export-warehouse/new/:id",
    parentId: "procedure",
    component: createExportWarehouse,
  }
};
